import { ForwardedRef, forwardRef, HTMLAttributes } from "react"
import cn from "classnames"

import { Text } from "ui-kit/components-branded/index"
import { Icon } from "components"
import { InputDevice } from "modules/Call/sdk"

interface Props extends HTMLAttributes<HTMLDivElement> {
    items?: InputDevice[]
    selectedId?: InputDevice["id"]
    handleSelect?: (id: InputDevice["id"]) => Promise<void>
    locked?: boolean
}

export const SelectorTooltip = forwardRef(
    (
        { selectedId, items, locked, handleSelect, className, ...props }: Props,
        ref: ForwardedRef<HTMLDivElement>
    ) => (
        <div ref={ref} className={cn("video-controls__overlay", className)} {...props}>
            <div className="video-controls__content">
                {items?.map(({ name, id }) => (
                    <div
                        key={id}
                        className={cn(
                            "is-flex is-justify-content-space-between video-controls__item",
                            {
                                "video-controls__item_is-clickable":
                                    items.length > 1 && selectedId !== id && !locked,
                            }
                        )}
                        onClick={() => {
                            items.length > 1 && selectedId !== id && !locked && handleSelect?.(id)
                        }}
                    >
                        <Text className="video-controls__label">{name || "По умолчанию"}</Text>
                        {selectedId === id && (
                            <Icon className="video-controls__check-mark" type="done" size={24} />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
)

SelectorTooltip.displayName = "SelectorTooltip"
